<div class="text-muted">
    <i class="fa fa-3x fa-cloud-upload"></i>
    <br/> Drag &amp; drop files here to upload, <br/>
    small or manually <a href="#">select files</a>.
</div>
